// Action creators extracted from UnitPlanModule.js

import React from "react";
import {
  UPDATE_FILTER_OBJECT,
  UPDATE_LEARNING_COURSE_FILTER_OBJECT,
  INIT_FILTER_OBJECT,
  SET_CURRENT_TAB,
  SET_CURRENT_UNIT_PLAN_TITLE,
  UPDATE_LOCAL_RESOURCE,
  INIT_LOCAL_RESOURCE,
  SET_UNIT_PLAN_MODE,
  SET_PROMPTS_VISIBILITY,
  SET_DIRECT_CREATE_UNIT_PLAN_MODE,
  SET_UNIT_PLAN_READ_ONLY,
  SWITCH_YEARLY_VIEW,
  SET_UNIT_PLAN_COUNT,
  SET_CURRENT_VIEW_TYPE,
  RESET_CURRENT_VIEW_TYPE,
  SET_COLLAPSABLE_DESC,
  SET_ACTIVE_UNIT_PLAN_ID,
  SET_ACTIVE_OWNER_UNIT_PLAN_ID,
  SET_CUSTOM_RIGHT_PANE,
  SET_SHOW_LEFT_PANE,
  TOGGLE_TODDLEPLAY,
  UPDATE_DISPLAY_SETTINGS,
  UPDATE_IMPORT_UNIT_FILTER_OBJECT,
  INIT_IMPORT_UNIT_FILTER_OBJECT,
  SET_SELECTED_IMPORT_UNIT_PLAN,
  SET_BULK_IMPORT_UNIT_PLANS,
  UPDATE_COMBINED_LIBRARY_FILTER,
  UPDATE_TODDLE_LIBRARY_FILTER,
  UPDATE_PLANNER_ELEMENT_SETS,
  UPDATE_TODDLE_LIBRARY_UNIT_PLAN_DETAILS,
  RESET_TODDLE_LIBRARY_UNIT_PLAN_DETAILS,
  UPDATE_TODDLE_LIBRARY_COURSE_INFO,
  SET_SCROLL_FIELD,
  SET_UNIT_AI_CONTEXT,
  UPDATE_COURSE_FILTER_SEARCH_TEXT,
  UPDATE_CLASS_FILTER_SEARCH_TEXT,
  UPDATE_INCLUDE_REFLECTIONS_OPTION,
  UPDATE_TODDLE_LIBRARY_UNIT_FEED_FILTER,
} from "./UnitPlanConstants";

// Action Creators
export const initLocalResource = () => {
  return {
    type: INIT_LOCAL_RESOURCE,
  };
};

export const updateLocalResource = data => {
  return {
    type: UPDATE_LOCAL_RESOURCE,
    data,
  };
};

export const updateCourseFilterSearchText = data => {
  return { type: UPDATE_COURSE_FILTER_SEARCH_TEXT, data: data };
};
export const updateClassFilterSearchText = data => {
  return { type: UPDATE_CLASS_FILTER_SEARCH_TEXT, data: data };
};

export const updateFilterObject = data => {
  return { type: UPDATE_FILTER_OBJECT, data: data };
};

export const updateLearningCourseFilterObject = data => {
  return { type: UPDATE_LEARNING_COURSE_FILTER_OBJECT, data: data };
};

export const updateDisplaySettings = data => {
  return { type: UPDATE_DISPLAY_SETTINGS, data: data };
};

export const initFilterObject = () => {
  return { type: INIT_FILTER_OBJECT };
};

export const updateImportUnitFilterObject = data => {
  return { type: UPDATE_IMPORT_UNIT_FILTER_OBJECT, data: data };
};

export const initImportUnitFilterObject = data => {
  return { type: INIT_IMPORT_UNIT_FILTER_OBJECT, data };
};

export const setSelectedImportUnitPlan = data => {
  return { type: SET_SELECTED_IMPORT_UNIT_PLAN, data };
};

export const setBulkImportUnitPlans = data => {
  return { type: SET_BULK_IMPORT_UNIT_PLANS, data };
};

export const setCurrentTab = data => {
  return { type: SET_CURRENT_TAB, data };
};

export const setCurrentUnitPlanTitle = data => {
  return { type: SET_CURRENT_UNIT_PLAN_TITLE, data };
};

export const setCurrentViewType = data => {
  return { type: SET_CURRENT_VIEW_TYPE, data };
};

export const setCollapsableDesc = data => {
  return { type: SET_COLLAPSABLE_DESC, data };
};

export const setActiveUnitPlanId = data => {
  return { type: SET_ACTIVE_UNIT_PLAN_ID, data };
};

export const setActiveOwnerUnitPlanId = data => {
  return { type: SET_ACTIVE_OWNER_UNIT_PLAN_ID, data };
};

export const setCustomRightPane = data => {
  return { type: SET_CUSTOM_RIGHT_PANE, data };
};

export const setShowLeftPane = data => {
  return { type: SET_SHOW_LEFT_PANE, data };
};

export const resetCurrentUnitPlanViewType = data => {
  return { type: RESET_CURRENT_VIEW_TYPE, data };
};

export const switchYearlyView = data => {
  return { type: SWITCH_YEARLY_VIEW, data };
};

export const setUnitPlanMode = data => {
  return { type: SET_UNIT_PLAN_MODE, data };
};
export const setPromptsVisibility = data => {
  return { type: SET_PROMPTS_VISIBILITY, data };
};
export const setDirectUnitCreateMode = data => {
  return { type: SET_DIRECT_CREATE_UNIT_PLAN_MODE, data };
};

export const setUnitPlanReadOnly = data => {
  return { type: SET_UNIT_PLAN_READ_ONLY, data };
};

export const setUnitPlanCount = data => {
  return { type: SET_UNIT_PLAN_COUNT, data };
};

export const updateToddleLibraryFilter = payload => ({
  type: UPDATE_TODDLE_LIBRARY_FILTER,
  payload,
});

export const updateToddleLibraryUnitFeedFilters = payload => ({
  type: UPDATE_TODDLE_LIBRARY_UNIT_FEED_FILTER,
  payload,
});

export const updatePlannerElementSets = payload => ({
  type: UPDATE_PLANNER_ELEMENT_SETS,
  payload,
});

export const updateToddleLibraryUnitPlanDetails = payload => ({
  type: UPDATE_TODDLE_LIBRARY_UNIT_PLAN_DETAILS,
  payload,
});

export const resetToddleLibraryUnitPlanDetails = () => ({
  type: RESET_TODDLE_LIBRARY_UNIT_PLAN_DETAILS,
});

export const updateCourseSelectionInfo = payload => ({
  type: UPDATE_TODDLE_LIBRARY_COURSE_INFO,
  payload,
});

export const toggleToddlePlay = data => {
  return {
    type: TOGGLE_TODDLEPLAY,
    data,
  };
};

export const updateCombinedLibraryFilters = data => {
  return { type: UPDATE_COMBINED_LIBRARY_FILTER, data };
};

export const setScrollField = data => {
  return {
    type: SET_SCROLL_FIELD,
    data,
  };
};

export const setUnitAIContext = data => {
  return {
    type: SET_UNIT_AI_CONTEXT,
    data,
  };
};

export const updateIncludeReflectionsOption = data => ({
  type: UPDATE_INCLUDE_REFLECTIONS_OPTION,
  data,
});
